import WeOfferBlock from './WeOfferBlock'
import WeOfferCardBlock from './WeOfferCardBlock'

export {
  WeOfferBlock,
  WeOfferCardBlock
}
